// @ts-nocheck
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import store from "../../redux/store";
import moonLight from "./../../assets/images/moon-light.svg?url";

function ThemeSwitcher({ dispatch }) {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedTheme } = store.getState().theme;

  const switchRef = useRef(null);

  const handleThemeSwitch = (selectedTheme, shouldSetLocalStorage) => {
    dispatch({
      type: "SET_THEME",
      payload: { selectedTheme }
    });

    // Remove all theme classes first
    document.body.classList.remove("light", "modern-blue");

    if (selectedTheme === "light") {
      document.body.classList.add("light");
    } else if (selectedTheme === "modern-blue") {
      document.body.classList.add("modern-blue");
    }
    // Dark is default, no class needed

    // Close the dropdown
    if (isOpen) {
      setIsOpen(false);
    }

    if (shouldSetLocalStorage) {
      localStorage.setItem("theme", selectedTheme);
    }
  };

  useEffect(() => {
    const cachedTheme = localStorage.getItem("theme") || "dark";
    handleThemeSwitch(cachedTheme, false);
  }, []);

  return (
    <li ref={switchRef} className="clickable">
      <img src={moonLight} onClick={() => setIsOpen(!isOpen)} alt="Moon/Light" />
      {isOpen && (
        <>
          <div onClick={() => setIsOpen(false)} className="overlay"></div>
          <div className="theme__switch__options">
            <div
              className={`theme__option row m-0 ${selectedTheme === "light" ? "active" : ""}`}
              onClick={() => handleThemeSwitch("light", true)}
            >
              <div className="theme-preview theme-preview-light"></div>
              <span>Light</span>
            </div>
            <div
              className={`theme__option row m-0 ${selectedTheme === "dark" ? "active" : ""}`}
              onClick={() => handleThemeSwitch("dark", true)}
            >
              <div className="theme-preview theme-preview-dark"></div>
              <span>Dark</span>
            </div>
            <div
              className={`theme__option row m-0 ${selectedTheme === "modern-blue" ? "active" : ""}`}
              onClick={() => handleThemeSwitch("modern-blue", true)}
            >
              <div className="theme-preview theme-preview-modern-blue"></div>
              <span>Modern Blue</span>
            </div>
          </div>
        </>
      )}
      {/*</div>*/}
    </li>
  );
}

const mapStateToProps = state => {
  return {
    selectedTheme: state.theme ? state.theme.selectedTheme : ""
  };
};

export default connect(mapStateToProps)(ThemeSwitcher);
